// NotFoundPage.js
import React from "react";
import { Container, Typography, Button, IconButton } from "@mui/material";
import { Link } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

const NotFoundPage = () => {
  return (
    <div className="container py-5 my-y">
      <Container maxWidth="sm" sx={{ textAlign: "center", mt: 5 }}>
        <Typography variant="h4" gutterBottom>
          <strong>404</strong> - Page Not Found
        </Typography>
        <Typography variant="body1" paragraph>
          Oops! The page you are looking for doesn't exist.
        </Typography>
        <IconButton
          component={Link}
          to="/"
          color="primary"
          aria-label="Return Home"
        >
          <ArrowBackIcon />
        </IconButton>
        <Button component={Link} to="/" variant="contained" color="primary">
          Return to Home
        </Button>
      </Container>
    </div>
  );
};

export default NotFoundPage;
